document.addEventListener("DOMContentLoaded", function () {
  const searchButtons = document.querySelectorAll(
    ".custom-header__search-button"
  );
  const searchOverlay = document.querySelector(
    ".custom-header__search-overlay"
  );
  const searchContainer = document.querySelector(
    ".custom-header__search-container"
  );
  const searchInput = searchContainer.querySelector("input"); // Assuming your input is inside the container
  const searchSubmitButton = searchContainer.querySelector("button"); // Assuming your button is inside the container
  const megaMenu = document.querySelector(".mega-menu-mobile");
  const header = document.querySelector(".custom-header");

  // Function to show search overlay and focus input
  function openSearchOverlay() {
    searchOverlay.style.display = "flex";
    document.body.classList.add("search-overlay-active");
    searchInput.focus(); // Auto-focus on input field
  }

  // Attach event listeners to all search buttons
  searchButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      openSearchOverlay();
    });
  });

  // Close overlay when clicking outside
  document.addEventListener("click", function (event) {
    if (
      document.body.classList.contains("search-overlay-active") &&
      !searchOverlay.contains(event.target) &&
      !event.target.closest(".custom-header__search-button")
    ) {
      searchOverlay.style.display = "none";
      document.body.classList.remove("search-overlay-active");
    }
  });

  // Close overlay with Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && searchOverlay.style.display === "flex") {
      searchOverlay.style.display = "none";
      document.body.classList.remove("search-overlay-active");
    }

    // Submit search when Enter is pressed
    if (event.key === "Enter" && searchOverlay.style.display === "flex") {
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  });

  // Submit button click event
  searchSubmitButton.addEventListener("click", function () {
    const query = searchInput.value.trim();
    if (query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  });

  // Mobile-specific behavior (Close Mega Menu when Search is clicked)
  const mobileSearchButtons = document.querySelectorAll(
    ".custom-header__search-button-mobile"
  );

  mobileSearchButtons.forEach((mobileSearchButton) => {
    mobileSearchButton.addEventListener("click", function () {
      megaMenu.classList.remove("active");
      header.classList.remove("active");
      openSearchOverlay(); // Ensure search overlay opens
    });
  });
});
